export const getEventsData = (t) => [
  {
    id: 1,
    slug: 'pyramid-valley-meditation-retreat',
    image: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=1200&h=800&fit=crop',
    date: { day: '05', month: 'Jan' },
    title: t('event_meditation_retreat_title'),
    description: t('event_meditation_retreat_description'),
    venue: t('event_common_venue'),
    content: t('event_meditation_retreat_content')
  },
  {
    id: 2,
    slug: 'conscious-living-workshop',
    image: 'https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?w=1200&h=800&fit=crop',
    date: { day: '22', month: 'Feb' },
    title: t('event_conscious_living_title'),
    description: t('event_conscious_living_description'),
    venue: t('event_common_venue'),
    content: t('event_conscious_living_content')
  },
  {
    id: 3,
    slug: 'breathwork-healing-circle',
    image: 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?w=1200&h=800&fit=crop',
    date: { day: '16', month: 'Mar' },
    title: t('event_breathwork_circle_title'),
    description: t('event_breathwork_circle_description'),
    venue: t('event_common_venue'),
    content: t('event_breathwork_circle_content')
  },
  {
    id: 4,
    slug: 'youth-mindfulness-camp',
    image: 'https://images.unsplash.com/photo-1472653431158-6364773b2a56?w=1200&h=800&fit=crop',
    date: { day: '12', month: 'Apr' },
    title: t('event_youth_mindfulness_title'),
    description: t('event_youth_mindfulness_description'),
    venue: t('event_common_venue'),
    content: t('event_youth_mindfulness_content')
  },
  {
    id: 5,
    slug: 'holistic-wellness-expo',
    image: 'https://images.unsplash.com/photo-1524499982521-1ffd58dd89ea?w=1200&h=800&fit=crop',
    date: { day: '27', month: 'May' },
    title: t('event_holistic_expo_title'),
    description: t('event_holistic_expo_description'),
    venue: t('event_common_venue'),
    content: t('event_holistic_expo_content')
  }
];
